import { AnnouncementVideoBase } from './AnnouncementVideoBase';
import { createVimeoHandler } from '../../../MediaController';
import { VimeoHandler } from '../../../MediaController/Video';
import { toBoolean } from '../../../Utility';
import { AnnouncementWidget } from '../AnnouncementWidget';
import { VimeoAnnouncementConfiguration } from '../types';
import type { PlayTimes } from '../PlayTimes';

export class AnnouncementVimeo extends AnnouncementVideoBase<VimeoAnnouncementConfiguration> {
    protected _playerElementId: string;
    protected _player: VimeoHandler;

    public declare configuration: VimeoAnnouncementConfiguration;

    constructor(
        configuration: VimeoAnnouncementConfiguration,
        widget: AnnouncementWidget,
        playTimes: PlayTimes
    ) {
        super(configuration, widget, playTimes);

        this._playerElementId = `vimeo_${configuration.id}_widget_${widget.id}`;

        this._player = createVimeoHandler({
            vimeoVideoId: configuration.vimeo_video_id,
            muted: toBoolean(widget.config.mute_videos),
            showSubtitles: Boolean(configuration.youtube_enable_cc),
            startTime: configuration.video_start_time,
        });
    }
}
